import { render, staticRenderFns } from "./ViewButtons.vue?vue&type=template&id=9f663cd2"
import script from "./ViewButtons.vue?vue&type=script&lang=js"
export * from "./ViewButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports